var path = 'pages/fund.html';
var html = "<div id=fundView-content data-ui-view></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/fund.html
// module id = vlXI
// module chunks = 1